import i18n from '../../i18n'

const PRASYMASTIPAS = {
  'seima-iregistravimas': {
    tipas: 'seima-iregistravimas',
    title: i18n.t('Prašymas įregistruoti juridinį faktą - Šeimos turtas'),
    routeList: 'seimaIregistravimasList',
    routeEdit: 'seimaIregistravimasPrasymas',
    routeView: 'seimaIregistravimasSteps',
    routeSign: 'seimaIregistravimasSteps',
  },
  'seima-perkelimas': {
    tipas: 'seima-perkelimas',
    title: i18n.t('Prašymas perkelti juridinį faktą - Šeimos turtas'),
    routeList: 'seimaPerkelimasList',
    routeEdit: 'seimaPerkelimasPrasymas',
    routeView: 'seimaPerkelimasSteps',
    routeSign: 'seimaPerkelimasSteps',
  },
  'seima-isregistravimas': {
    tipas: 'seima-isregistravimas',
    title: i18n.t('Prašymas išregistruoti juridinį faktą - Šeimos turtas'),
    routeList: 'seimaIsregistravimasList',
    routeEdit: 'seimaIsregistravimasPrasymas',
    routeView: 'seimaIsregistravimasSteps',
    routeSign: 'seimaIsregistravimasSteps',
  },
  'bendra-iregistravimas': {
    tipas: 'bendra-iregistravimas',
    title: i18n.t(
      'Prašymas įregistruoti juridinį faktą - Bendroji jungtinė sutuoktinių nuosavybė'
    ),
    routeList: 'bendraIregistravimasList',
    routeEdit: 'bendraIregistravimasPrasymas',
    routeView: 'bendraIregistravimasSteps',
    routeSign: 'bendraIregistravimasSteps',
  },
  'pirmenybe-iregistravimas': {
    tipas: 'pirmenybe-iregistravimas',
    title: i18n.t(
      'Prašymas įregistruoti juridinį faktą - Pirmenybės teisės pirkti parduodamas dalis, esančias bendrąja nuosavybe, atsisakymas'
    ),
    routeList: 'pirmenybeIregistravimasList',
    routeEdit: 'pirmenybeIregistravimasPrasymas',
    routeView: 'pirmenybeIregistravimasSteps',
    routeSign: 'pirmenybeIregistravimasSteps',
  },
  'pirmenybe-isregistravimas': {
    tipas: 'pirmenybe-isregistravimas',
    title: i18n.t(
      'Prašymas išregistruoti juridinį faktą - Pirmenybės teisės pirkti parduodamas dalis, esančias bendrąja nuosavybe, atsisakymas'
    ),
    routeList: 'pirmenybeIsregistravimasList',
    routeEdit: 'pirmenybeIsregistravimasPrasymas',
    routeView: 'pirmenybeIsregistravimasSteps',
    routeSign: 'pirmenybeIsregistravimasSteps',
  },
  'nuoma-iregistravimas': {
    tipas: 'nuoma-iregistravimas',
    title: i18n.t(
      'Prašymas įregistruoti juridinį faktą - Sudaryta nuomos sutartis'
    ),
    routeList: 'nuomaIregistravimasList',
    routeEdit: 'nuomaIregistravimasPrasymas',
    routeView: 'nuomaIregistravimasSteps',
    routeSign: 'nuomaIregistravimasSteps',
  },
  'nuoma-nutraukimas': {
    tipas: 'nuoma-nutraukimas',
    title: i18n.t(
      'Prašymas nutraukti sutartį ir išregistruoti juridinį faktą - Sudaryta nuomos sutartis'
    ),
    routeList: 'nuomaNutraukimasList',
    routeEdit: 'nuomaNutraukimasPrasymas',
    routeView: 'nuomaNutraukimasSteps',
    routeSign: 'nuomaNutraukimasSteps',
  },
  'nuoma-isregistravimas': {
    tipas: 'nuoma-isregistravimas',
    title: i18n.t(
      'Prašymas išregistruoti juridinį faktą - Sudaryta nuomos sutartis'
    ),
    routeList: 'nuomaIsregistravimasList',
    routeEdit: 'nuomaIsregistravimasPrasymas',
    routeView: 'nuomaIsregistravimasSteps',
    routeSign: 'nuomaIsregistravimasSteps',
  },
  'panauda-iregistravimas': {
    tipas: 'panauda-iregistravimas',
    title: i18n.t(
      'Prašymas įregistruoti juridinį faktą - Sudaryta panaudos sutartis'
    ),
    routeList: 'panaudaIregistravimasList',
    routeEdit: 'panaudaIregistravimasPrasymas',
    routeView: 'panaudaIregistravimasSteps',
    routeSign: 'panaudaIregistravimasSteps',
  },
  'panauda-nutraukimas': {
    tipas: 'panauda-nutraukimas',
    title: i18n.t(
      'Prašymas nutraukti sutartį ir išregistruoti juridinį faktą - Sudaryta panaudos sutartis'
    ),
    routeList: 'panaudaNutraukimasList',
    routeEdit: 'panaudaNutraukimasPrasymas',
    routeView: 'panaudaNutraukimasSteps',
    routeSign: 'panaudaNutraukimasSteps',
  },
  'panauda-isregistravimas': {
    tipas: 'panauda-isregistravimas',
    title: i18n.t(
      'Prašymas išregistruoti juridinį faktą - Sudaryta panaudos sutartis'
    ),
    routeList: 'panaudaIsregistravimasList',
    routeEdit: 'panaudaIsregistravimasPrasymas',
    routeView: 'panaudaIsregistravimasSteps',
    routeSign: 'panaudaIsregistravimasSteps',
  },
  'subnuomos-iregistravimas': {
    tipas: 'subnuomos-iregistravimas',
    title: i18n.t(
      'Prašymas įregistruoti juridinį faktą - Sudaryta subnuomos sutartis'
    ),
    routeList: 'subnuomaIregistravimasList',
    routeEdit: 'subnuomaIregistravimasPrasymas',
    routeView: 'subnuomaIregistravimasSteps',
    routeSign: 'subnuomaIregistravimasSteps',
  },
  'subnuomos-nutraukimas': {
    tipas: 'subnuomos-nutraukimas',
    title: i18n.t(
      'Prašymas nutraukti sutartį ir išregistruoti juridinį faktą - Sudaryta subnuomos sutartis'
    ),
    routeList: 'subnuomaNutraukimasList',
    routeEdit: 'subnuomaNutraukimasPrasymas',
    routeView: 'subnuomaNutraukimasSteps',
    routeSign: 'subnuomaNutraukimasSteps',
  },
  'subnuomos-isregistravimas': {
    tipas: 'subnuomos-isregistravimas',
    title: i18n.t(
      'Prašymas išregistruoti juridinį faktą - Sudaryta subnuomos sutartis'
    ),
    routeList: 'subnuomaIsregistravimasList',
    routeEdit: 'subnuomaIsregistravimasPrasymas',
    routeView: 'subnuomaIsregistravimasSteps',
    routeSign: 'subnuomaIsregistravimasSteps',
  },
  'preliminari-iregistravimas': {
    tipas: 'preliminari-iregistravimas',
    title: i18n.t(
      'Prašymas įregistruoti juridinį faktą - Sudaryta preliminarioji pirkimo-pardavimo sutartis'
    ),
    routeList: 'preliminariIregistravimasList',
    routeEdit: 'preliminariIregistravimasPrasymas',
    routeView: 'preliminariIregistravimasSteps',
    routeSign: 'preliminariIregistravimasSteps',
  },
  'preliminari-nutraukimas': {
    tipas: 'preliminari-nutraukimas',
    title: i18n.t(
      'Prašymas nutraukti sutartį ir išregistruoti juridinį faktą - Sudaryta preliminarioji pirkimo-pardavimo sutartis'
    ),
    routeList: 'preliminariNutraukimasList',
    routeEdit: 'preliminariNutraukimasPrasymas',
    routeView: 'preliminariNutraukimasSteps',
    routeSign: 'preliminariNutraukimasSteps',
  },
  'preliminari-isregistravimas': {
    tipas: 'preliminari-isregistravimas',
    title: i18n.t(
      'Prašymas išregistruoti juridinį faktą - Sudaryta preliminarioji pirkimo-pardavimo sutartis'
    ),
    routeList: 'preliminariIsregistravimasList',
    routeEdit: 'preliminariIsregistravimasPrasymas',
    routeView: 'preliminariIsregistravimasSteps',
    routeSign: 'preliminariIsregistravimasSteps',
  },
}

const PRASYMASBUSENA = {
  rengiamas: {
    key: 'rengiamas',
    title: i18n.t('Rengiamas'),
  },
  patvirtinti: {
    key: 'patvirtinti',
    title: i18n.t('Patvirtinti'),
  },
  laukia_patvirtinimo: {
    key: 'laukia_patvirtinimo',
    title: i18n.t('Laukia pasirašymo'),
  },
  laukia_apmokejimo: {
    key: 'laukia_apmokejimo',
    title: i18n.t('Laukia apmokėjimo'),
  },
  perduotas: {
    key: 'perduotas',
    title: i18n.t('Perduotas'),
  },
  grazintas: {
    key: 'grazintas',
    title: i18n.t('Grąžintas'),
  },
  nepatikslintas: {
    key: 'nepatikslintas',
    title: i18n.t('Nepatikslintas'),
  },
  iregistruotas: {
    key: 'iregistruotas',
    title: i18n.t('Įregistruotas'),
  },
  atmestas: {
    key: 'atmestas',
    title: i18n.t('Atmestas'),
  },
  nutrauktas: {
    key: 'nutrauktas',
    title: i18n.t('Nutrauktas'),
  },
}

const ASMUOROLE = {
  savininkas: {
    key: 'savininkas',
    title: i18n.t('Savininkas'),
  },
  nuomotojas: {
    key: 'nuomotojas',
    title: i18n.t('Nuomotojas'),
  },
  nuomininkas: {
    key: 'nuomininkas',
    title: i18n.t('Nuomininkas'),
  },
  atstovas: {
    key: 'atstovas',
    title: i18n.t('Atstovas'),
  },
  panauda_davejas: {
    key: 'panauda_davejas',
    title: i18n.t('Panaudos davėjas'),
  },
  panauda_gavejas: {
    key: 'panauda_gavejas',
    title: i18n.t('Panaudos gavėjas'),
  },
  subnuomotojas: {
    key: 'subnuomotojas',
    title: i18n.t('Subnuomotojas'),
  },
  subnuomininkas: {
    key: 'subnuomininkas',
    title: i18n.t('Subnuomininkas'),
  },
  pirkejas: {
    key: 'pirkejas',
    title: i18n.t('Pirkėjas'),
  },
  pardavejas: {
    key: 'pardavejas',
    title: i18n.t('Pardavėjas'),
  },
}

const BUSENATEKSTAS = {
  rengti: {
    title: i18n.t('Grąžinimas'),
    message: i18n.t(
      'Dokumento pasirašymas bus atšauktas ir dokumentas grąžintas duomenų teikėjui. Ar norite tęsti?'
    ),
    messageCancel: i18n.t('Grąžinimas negalimas, aptikta kritinių klaidų.'),
    checkErrors: false,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  perduoti: {
    title: i18n.t('Perdavimas'),
    message: i18n.t('Ar norite duomenis perduoti registrui?'),
    messageCancel: i18n.t('Perdavimas negalimas, aptikta kritinių klaidų.'),
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  patvirtinti: {
    title: i18n.t('Patvirtinimas'),
    message: i18n.t('Ar norite patvirtinti duomenis?'),
    messageCancel: i18n.t('Perdavimas negalimas, aptikta kritinių klaidų.'),
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  moketi: {
    title: i18n.t('Mokėjimas'),
    message: i18n.t(
      'Sumokėjus už paslaugas pranešimas bus perduotas registrui'
    ),
    messageCancel: i18n.t('Perdavimas negalimas, aptikta kritinių klaidų.'),
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  pasirasyti: {
    title: i18n.t('Pasirašymas'),
    message: i18n.t('Ar tikrai norite pasirašyti?'),
    messageCancel: i18n.t('Pasirašymas negalimas, aptikta kritinių klaidų.'),
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
  },
  grazinti: {
    title: i18n.t('Grąžinimas tikslinti'),
    message: i18n.t('Ar norite duomenis grąžinti tikslinti?'),
    messageCancel: '',
    checkErrors: true,
    terminas: i18n.t('Grąžinimo tikslinti terminas'),
    aprasymas: i18n.t('Sprendimo motyvai'),
    motyvas: i18n.t('Sprendimo motyvai'),
    pagrindas: i18n.t(
      'Sprendimą pagrindžiančios procesinės ir materialinės teisės normos'
    ),
    atmetimasAprasymas: '',
    terminoPraleidimoPriezastis: i18n.t('Termino praleidimo priežastis'),

    terminasTooltip: 'Modalas būsena. Grąžintas. Terminas',
    aprasymasTooltip: 'Modalas būsena. Grąžintas. Aprašymas',
    motyvasTooltip: 'NtrPaslaugos. Modalas būsena. Grąžintas. Motyvas',
    pagrindasTooltip: 'NtrPaslaugos. Modalas būsena. Grąžintas. Pagrindas',
    atmetimasAprasymasTooltip: '',
    terminoPraleidimoPriezastisTooltip:
      'Modalas būsena. Grąžintas. Termino praleidimo priežastis',
  },
  iregistruoti: {
    title: i18n.t('Registravimas'),
    message: i18n.t('Ar norite duomenis įrašyti į registrą?'),
    messageCancel: i18n.t('Įregistravimas negalimas, aptikta kritinių klaidų.'),
    checkErrors: true,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: '',
    terminoPraleidimoPriezastis: i18n.t('Termino praleidimo priežastis'),

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: '',
    terminoPraleidimoPriezastisTooltip:
      'Modalas būsena. Įregistruotas. Termino praleidimo priežastis',
  },
  atmesti: {
    title: i18n.t('Atmetimas'),
    message: i18n.t('Ar norite duomenis atmesti?'),
    messageCancel: '',
    checkErrors: false,
    terminas: '',
    priezastis: '',
    aprasymas: '',
    atmetimasAprasymas: i18n.t('Sprendimo motyvai'),
    atmetimasMotyvas: i18n.t('Sprendimo motyvai'),
    atmetimasPagrindas: i18n.t(
      'Sprendimą pagrindžiančios procesinės ir materialinės teisės normos'
    ),
    terminoPraleidimoPriezastis: i18n.t('Termino praleidimo priežastis'),

    terminasTooltip: '',
    priezastisTooltip: '',
    aprasymasTooltip: '',
    atmetimasAprasymasTooltip: 'Modalas būsena. Atmestas. Aprašymas',
    atmetimasMotyvasTooltip: 'NtrPaslaugos. Modalas būsena. Atmestas. Motyvas',
    atmetimasPagrindasTooltip:
      'NtrPaslaugos. Modalas būsena. Atmestas. Pagrindas',
    terminoPraleidimoPriezastisTooltip:
      'Modalas būsena. Atmestas. Termino praleidimo priežastis',
  },
  atsaukti: {
    title: i18n.t('Atšaukimas asmens prašymu'),
  },
}

export default {
  mixins: { i18n },
  prasymasTipas: PRASYMASTIPAS,
  prasymasBusena: PRASYMASBUSENA,
  asmuoRole: ASMUOROLE,
  busenaTekstas: BUSENATEKSTAS,
  getPrasymasTipas(prasymasTipas) {
    return PRASYMASTIPAS[prasymasTipas]
      ? PRASYMASTIPAS[prasymasTipas]
      : { tipas: prasymasTipas }
  },
  getPrasymasBusena(busena) {
    return PRASYMASBUSENA[busena]
      ? PRASYMASBUSENA[busena]
      : { key: busena, title: busena }
  },
  getAsmuoRole(roleObjekte) {
    return ASMUOROLE[roleObjekte]
      ? ASMUOROLE[roleObjekte]
      : { title: roleObjekte }
  },
  getBusenaTekstas(busena) {
    return BUSENATEKSTAS[busena] ? BUSENATEKSTAS[busena] : {}
  },
}
